import React from "react";
import { Modal, Form } from "react-bootstrap";
import "../GeneralSettings.css";
import { ButtonBlue, ButtonLightGrey } from "../../HouseStyle/Components/Buttons"
import { BorderedDropDown } from "../../HouseStyle/Components/DropDowns";
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function DefaultVATModal({
    show,
    onHide,
    values,
    onChange,
    onSave,
}) {
    // Create options in the format BorderedDropDown expects
    const createVatOptions = (fieldName) => [
        { 
            title: "Hoog tarief", 
            value: "high", 
            onClick: () => onChange(fieldName, "high") 
        },
        { 
            title: "Laag tarief", 
            value: "reduced", 
            onClick: () => onChange(fieldName, "reduced") 
        },
        { 
            title: "Verlaagd tarief", 
            value: "reduced2", 
            onClick: () => onChange(fieldName, "reduced2") 
        },
    ];

    return (
        <Modal show={show} onHide={onHide} centered id="modalBlueprint" size="lg">
            <Modal.Header className="modalTop justify-content-between" closeButton={false}>
                <h4 className="mb-0 fw-semibold">Standaard BTW instellingen</h4>
                <button
                    type="button"
                    className="vat-modal-x"
                    aria-label="Close"
                    onClick={onHide}
                >
                    <FontAwesomeIcon icon={faXmark} className="closeModal"/>
                </button>
            </Modal.Header>
            <Modal.Body className="modalCenter">
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Standaard product BTW</Form.Label>
                        <BorderedDropDown
                            placeholder="Selecteer BTW tarief"
                            options={createVatOptions("product")}
                            selectedValue={values?.product || ""}
                            setSelectedValue={(value) => onChange("product", value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Standaard verzending BTW</Form.Label>
                        <BorderedDropDown
                            placeholder="Selecteer BTW tarief"
                            options={createVatOptions("shipping")}
                            selectedValue={values?.shipping || ""}
                            setSelectedValue={(value) => onChange("shipping", value)}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Standaard betaling BTW</Form.Label>
                        <BorderedDropDown
                            placeholder="Selecteer BTW tarief"
                            options={createVatOptions("payment")}
                            selectedValue={values?.payment || ""}
                            setSelectedValue={(value) => onChange("payment", value)}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer className="modalBottom d-flex justify-content-between">
                    <ButtonLightGrey text="Annuleren" onClickFunction={onHide} />
                    <ButtonBlue text="Opslaan" onClickFunction={onSave} />
            </Modal.Footer>
        </Modal>
    );
}